import { useCurrentWorkspace } from "./useCurrentWorkspace";

export function useCurrentWorkspaceId() {
  const workspace = useCurrentWorkspace();
  return workspace?.id ?? null;
}
